import { render } from "./CliDDConfirmationSection.vue?vue&type=template&id=0da28032&ts=true"
import script from "./CliDDConfirmationSection.vue?vue&type=script&lang=ts"
export * from "./CliDDConfirmationSection.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__